<template>
    <client-page>
        <sub-visual v-bind="visual" />

        <div class="client-content-wrap pb-0">
            <section class="client-section pb-0">
                <v-container>
                    <business-intro v-bind="intro" />
                </v-container>
            </section>
        </div>
        <div class="client-content-wrap">
            <scrolldown-tail />

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">주요 프로그램</h2>
                    </div>

                    <v-row>
                        <v-col v-for="(program, index) in programs" :key="index" cols="12" lg="6">
                            <v-card max-width="588" color="#ddd" outlined class="border-radius-16 text-center h-100 mx-auto">
                                <v-img :src="program.image" alt="" />
                                <v-card-title class="justify-center pt-lg-40">
                                    <h3 class="tit tit--sm primary--text">
                                        {{ program.title }}
                                    </h3>
                                </v-card-title>
                                <v-card-text class="pb-lg-40">
                                    <p v-html="program.texts" class="page-text page-text--lg" />
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </section>
        </div>

        <div class="client-content-wrap new-story">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">새로운 변화의 이야기</h2>
                        <p class="tit tit--sm font-weight-medium mt-18 mt-md-24">
                            함께 가꾸는 지역사회, 모두를 위한 울타리 <br class="d-md-none">
                            With You, With Can
                        </p>
                    </div>

                    <v-row justify="center">
                        <v-col v-for="(story, index) in stories" :key="index" cols="6" lg="4">
                            <v-img :src="story" alt="" max-width="384" class="border-radius-16 mx-auto" />
                        </v-col>
                    </v-row>
                </v-container>
            </section>
        </div>

        <section>
            <bottom-banner :item="banner" />
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import BusinessIntro from "@/components/client/business/business-intro.vue";
import ProgramList from "@/components/client/business/program-list.vue";
import BottomBanner from "@/components/client/business/bottom-banner.vue";
import ScrolldownTail from "@/components/dumb/scrolldown-tail.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        BusinessIntro,
        ProgramList,
        BottomBanner,
        ScrolldownTail,
    },
    data() {
        return {
            visual: {
                sh: "국내복지사업",
                tabActive: "지역사회복지사업",
                text: "우리는 단순한 지원을 넘어, 지속 가능한 변화를 만들어 갑니다.",
                bg: "/images/business/domestic/visual.jpg",
                mobile: "/images/business/domestic/mobile-visual.jpg",
            },
            intro: {
                image: "/images/business/domestic/community/intro.jpg",
                title: "지역사회복지사업",
                texts: "지역사회 내 취약계층과 주민이 함께 성장할 수 있는 환경을 조성하고, <br class='d-none d-xl-block' />보다 안정적이고 지속 가능한 공동체를 만들기 위해 지역사회복지사업을 펼치고 있습니다. <br class='d-none d-xl-block' />주민 간 교류와 협력을 통해 현장의 문제를 발굴하고, 다양한 복지 프로그램과 네트워크를 운영하며 실질적인 변화를 이끌어냅니다.",
            },
            programs: [
                {
                    image: "/images/business/domestic/community/program-1.jpg",
                    title: "지역사회복지",
                    texts: "종합복지관을 운영하여 지역사회 내 취약계층과 주민의 복지 욕구를 <br class='d-none d-xl-block' />반영한 맞춤형 서비스를 제공하고 있습니다. 더불어 지역기반 중심의 <br class='d-none d-xl-block' />지역조직화 사업과 돌봄센터, 어린이집 운영을 통한 영유아 자녀의 <br class='d-none d-xl-block' />양육과 보육을 지속적으로 지원합니다.",
                },
                {
                    image: "/images/business/domestic/community/program-2.jpg",
                    title: "취약계층 맞춤 지원",
                    texts: "저소득층 주민들이 직무교육·취업연계 등을 통해 <br class='d-none d-xl-block' />경제적 자립 기반 마련하도록 돕습니다. <br class='d-none d-xl-block' />발달장애인 등 돌봄이 필요한 이웃에게 일상생활 <br class='d-none d-xl-block' />및 사회적응훈련 서비스를 제공합니다.",
                },
                {
                    image: "/images/business/domestic/community/program-3.jpg",
                    title: "지역사회 네트워크",
                    texts: "정부, 지자체 및 기업들과 협력하여 <br class='d-none d-xl-block' />지역사회에 필요한 사업을 기획하고, 지속적인 네트워크를 통해 <br class='d-none d-xl-block' />사업을 진행하여 지역사회의 변화를 도모합니다.",
                },
                {
                    image: "/images/business/domestic/community/program-4.jpg",
                    title: "지역사회 조직 및 역량강화",
                    texts: "주민이 주도적으로 지역 문제를 해결하고 공동체 의식을 함양할 수 있도록 <br class='d-none d-xl-block' />워크숍·교육·문화행사 등 다양한 활동을 기획합니다.",
                },
            ],
            stories: [
                "/images/business/domestic/community/story-1.jpg",
                "/images/business/domestic/community/story-2.jpg",
                "/images/business/domestic/community/story-3.jpg",
                //
            ],
            banner: {
                image: "/images/business/domestic/job/bottom-banner.jpg",
                mobile: "/images/business/domestic/job/bottom.jpg",
                white: true,
            },
        };
    },
};
</script>

<style lang="scss" scoped>
.process-list {
    > [class*="col"] {
        .process-card {
            padding: 40px 14px;
            height: 100%;
            border-radius: 16px;
            max-width: 400px;
            margin: 0 auto;
            word-break: keep-all;
        }
        &:not(:last-child) {
            .process-card {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    right: 50%;
                    bottom: -28px;
                    transform: translateX(50%) rotate(90deg);
                    width: 24px;
                    height: 24px;
                    background: url(/images/guide/legacy/process-arrow.svg) no-repeat center;
                }
            }
        }
    }
}
.new-story {
    &::before {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        content: "";
        background-image: url(/images/business/domestic/community/new-story.jpg);
        background-repeat: no-repeat;
        background-size: cover;
        background-position-x: center;
        background-position-y: 0;
        width: 100%;
        height: 400px;
    }
    .client-section {
        position: relative;
        z-index: 1;
    }
}
@media (min-width: 1024px) {
    .process-list {
        > [class*="col"] {
            &:not(:last-child) {
                .process-card {
                    position: relative;
                    &::after {
                        content: "";
                        position: absolute;
                        right: -32px;
                        bottom: 50%;
                        transform: translatey(50%);
                        width: 24px;
                        height: 24px;
                    }
                }
            }
        }
    }
    .new-story {
        &::before {
            height: 505px;
        }
    }
}
</style>